'use es6';

import tinymce from 'tinymce';
import { getPopoverLinkSettings, onLinkUpdate } from './shared';
import { addControls } from './controls';
import { __HS_LINK } from '../constants/plugins';
import { getOpenFilePicker } from '../utils/file';
import { getFetchAnchors } from '../utils/anchor';
import { getFetchFileByUrl } from 'tinymce-data/api/FileManager';
import { getFetchContentPageList, getFetchPageBySlug, getFetchMeetingBySlug, getFetchMeetingsByUsers } from 'tinymce-data/api/Content';
import { addPostProcessTransform } from '../utils/transformer';
import { hslinkConfig } from '../constants/hslink';
import { bindHrefAndLinkText, unlinkIfInvalid } from '../utils/link';
export const HS_LINK = __HS_LINK;
function linkPlugin(editor) {
  const {
    apiClient
  } = editor.settings;
  const linkSettings = getPopoverLinkSettings(editor);
  addControls(Object.assign({
    editor,
    pluginName: HS_LINK,
    onSelectFile: getOpenFilePicker(editor),
    fetchPages: getFetchContentPageList(apiClient),
    onChangeLink: (target, link, action) => {
      onLinkUpdate(editor, target, link, action);
    },
    fetchPageBySlug: getFetchPageBySlug(apiClient),
    fetchFileByUrl: getFetchFileByUrl(apiClient),
    fetchMeetingsByUsers: getFetchMeetingsByUsers(apiClient),
    fetchMeetingBySlug: getFetchMeetingBySlug(apiClient),
    fetchAnchors: getFetchAnchors(editor)
  }, linkSettings));
  if (linkSettings[hslinkConfig.ALLOW_RAW_LINKS_ONLY]) {
    // Make sure `href` & `innerHTML` of the link node are kept in sync
    addPostProcessTransform(editor, () => {
      const node = editor.selection.getNode();
      if (node.tagName === 'A') {
        bindHrefAndLinkText(node);
        unlinkIfInvalid(editor);
      }
    });
  }
}
tinymce.PluginManager.add(HS_LINK, linkPlugin);